export default __webpack_public_path__ + "static/media/frame-3.d822e674.jpg";